import { render, staticRenderFns } from "./nav-item.vue?vue&type=template&id=b49f9098&scoped=true"
import script from "./nav-item.vue?vue&type=script&lang=js"
export * from "./nav-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49f9098",
  null
  
)

export default component.exports